import { render, staticRenderFns } from "./BrowserAlert.vue?vue&type=template&id=1b624d1d&scoped=true"
import script from "./BrowserAlert.vue?vue&type=script&lang=js"
export * from "./BrowserAlert.vue?vue&type=script&lang=js"
import style0 from "./BrowserAlert.vue?vue&type=style&index=0&id=1b624d1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b624d1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
installComponents(component, {
  VAlert,
})
